// Utils
import { component } from 'picoapp';

import choozy from 'utils/choozy';

export default component(async (node) => {
  const { viewSelector: viewSelectors } = choozy(node);

  const changeView = (event) => {
    const { target } = event;
    const { name, value } = target;

    if (name.includes('size-guide-units')) {
      node.dataset.activeUnits = value;
    } else if (name.includes('size-guide-tab')) {
      node.dataset.activeTab = value;
    }
  };

  if (viewSelectors) {
    viewSelectors.forEach((viewSelector) => {
      viewSelector.addEventListener('change', changeView);
    });
  }
});
